var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 66.6016L83.3984 75V79.1016H16.6016V75L25 66.6016V45.8984C25 39.388 26.6276 33.724 29.8828 28.9062C33.2682 24.0885 37.8906 20.9635 43.75 19.5312V16.6016C43.75 14.9089 44.3359 13.4766 45.5078 12.3047C46.6797 11.0026 48.1771 10.3516 50 10.3516C51.8229 10.3516 53.3203 11.0026 54.4922 12.3047C55.6641 13.4766 56.25 14.9089 56.25 16.6016V19.5312C62.1094 20.9635 66.6667 24.0885 69.9219 28.9062C73.3073 33.724 75 39.388 75 45.8984V66.6016ZM50 91.6016C47.6562 91.6016 45.638 90.8203 43.9453 89.2578C42.3828 87.5651 41.6016 85.612 41.6016 83.3984H58.3984C58.3984 85.612 57.5521 87.5651 55.8594 89.2578C54.1667 90.8203 52.2135 91.6016 50 91.6016Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.561eb970ba138e59be70fe351be93023.svg";
export { ForwardRef as ReactComponent };